module.exports = __webpack_public_path__ + "img/potential-events_super-bowl.9c94f9ed.jpg";